import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Field, change } from 'redux-form';
import { connect } from 'react-redux';
import { Button, FormGroup } from 'reactstrap';
import Select from '../../../common/forms/select/Select';
import {
  dobIsRequired,
  isRequired,
  validateCustomerByAge,
} from '../../../../utils/validators';
import {
  getPostpaidBookingItineraryFoodGroup,
  deselectPostpaidBookingSeat,
  clearCustomers,
} from '../../../../actions';
import {
  GENDERS,
  RELATIONSHIP,
  RELATIONSHIP_TO_MINOR,
  RELATIONSHIP_WITH_PERMIT,
} from '../../../../config/constants';
import {
  DEFAULT_ID_COUNTRY_OF_ORIGIN_OPTION,
  DEFAULT_IDENTIFICATION_TYPE_ID_OPTION,
} from '../../../../config/defaults';
import { DATE_TIME_FORMAT } from '../../../../config/locale';
import CustomerInputGroup from '../../../common/forms/CustomerInputGroup';
import PassengerForm from '../../../modules/booking/passengers/PassengerForm';
import { orderBy } from '../../../../utils/array';
import FormItem from '../../../common/forms/FormItem';
import { enumToSelectOptions } from '../../../../utils/enum';
import TextInput from '../../../common/forms/input/TextInput';
import Badge from '../../../common/Badge';
import { tzNormalizeDate } from '../../../../utils/date';
import KidPassengerForm from '../../../modules/booking/passengers/KidPassengerForm';

// TODO: refactor and create one bookingPassengerForm
// need to get rid of getPostpaidBookingItineraryFoodGroup call
// in order to make it reusable
class PostpaidBookingPassengerForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customerDisabled: false,
      underageDisabled: true,
      showUnderageExtraFields: false,
      grownUpPassenger: null,
      underagePassenger: null,
      relationship: null,
      needNotarizedPermit: false,
      isAgeBetween15And18: false,
      isValidAge: true,
      travelsOnly: false,
      showKidForm: false,
    };
  }

  componentDidMount() {
    this.onMount();
  }

  onMount = () => {
    const { dispatchGetPostpaidBookingItineraryFoodGroup, itineraryId } =
      this.props;

    dispatchGetPostpaidBookingItineraryFoodGroup(itineraryId);
  };

  onChangeGrownUpPassenger = (customer) => {
    const { passenger, dispatchChange, dispatchClearCustomers } = this.props;

    dispatchClearCustomers();

    const selectedCustomer = customer && customer.firstName;

    const validAge = customer && validateCustomerByAge(customer);
    const validAgeBetween15And18 =
      customer && !validAge && validateCustomerByAge(customer, 15);

    if (customer && validAge) {
      dispatchChange(
        'PostpaidBookingPassengersForm',
        `${passenger}.parent`,
        null,
      );
    } else {
      dispatchChange(
        'PostpaidBookingPassengersForm',
        `${passenger}.parent.relationship`,
        null,
      );
    }

    dispatchChange('PassengersForm', `${passenger}.parent`, null);
    this.setState({
      grownUpPassenger: customer && customer.fullName,
      underagePassenger: null,
      relationship: null,
      showUnderageExtraFields: !validAge,
      underageDisabled: !selectedCustomer || validAge,
      isValidAge: validAge,
      isAgeBetween15And18: validAgeBetween15And18,
      travelsOnly: false,
      needNotarizedPermit: false,
    });
  };

  onChangeUnderagePassenger = (customer) => {
    const { passenger, dispatchChange } = this.props;

    dispatchChange(
      'PostpaidBookingPassengersForm',
      `${passenger}.parent.relationship`,
      null,
    );

    this.setState({
      relationship: null,
      needNotarizedPermit: false,
      travelsOnly: false,
      underagePassenger: customer && customer.fullName,
    });
  };

  onChangeRelationship = (relationship) => {
    this.setState({ relationship: relationship && relationship.label });

    if (relationship && relationship.label) {
      this.setState({
        needNotarizedPermit: Object.values(RELATIONSHIP_WITH_PERMIT).some(
          (r) => r.label === relationship.label,
        ),
      });
      if (relationship.label === RELATIONSHIP_TO_MINOR.TRAVELS_ALONE.label) {
        this.setState({ travelsOnly: true });
      } else {
        this.setState({ travelsOnly: false });
      }
    } else {
      this.setState({ needNotarizedPermit: false });
    }
  };

  onClickDeselectSeat = () => {
    const {
      seatReservations,
      index,
      dispatchDeselectPostpaidBookingSeat,
      fields,
    } = this.props;

    const {
      value: seatReservationId,
      label: seatId,
      itineraryId,
    } = seatReservations[index];

    fields.remove(index);

    dispatchDeselectPostpaidBookingSeat({
      seatReservationId,
      itineraryId,
      seatId,
    });
  };

  onClickEditCustomer = (kindOfPassenger) => {
    const initialValues = this.state[`${kindOfPassenger}InitialValues`];
    const passenger = this.state[`${kindOfPassenger}Passenger`];

    if (initialValues !== passenger) {
      const jsonPassenger = JSON.parse(passenger);

      const identificationTypeId = jsonPassenger.identificationType
        ? {
            value: jsonPassenger.identificationType.id,
            label: jsonPassenger.identificationType.name,
          }
        : DEFAULT_IDENTIFICATION_TYPE_ID_OPTION;

      const newInitialValues = JSON.stringify({
        firstName: jsonPassenger.firstName,
        lastName: jsonPassenger.lastName,
        gender: GENDERS.find((gender) => gender.value === jsonPassenger.gender),
        identificationTypeId,
        idDocumentNumber: jsonPassenger.idDocumentNumber,
        idCountryOfOrigin: DEFAULT_ID_COUNTRY_OF_ORIGIN_OPTION,
        email: jsonPassenger.email,
        dateOfBirth: jsonPassenger.dob,
        mobilePhone: jsonPassenger.mobilePhone,
        id: jsonPassenger.id,
      });

      let state = {
        underageInitialValues: newInitialValues,
      };

      if (kindOfPassenger === 'grownUp')
        state = { grownUpInitialValues: newInitialValues };

      this.setState(state);
    }
  };

  handleToggleKidForm = () => {
    const { showKidForm } = this.state;
    const { passenger, dispatchChange } = this.props;
    if (showKidForm) {
      this.setState({ showKidForm: false });
      dispatchChange('PostpaidBookingPassengersForm', `${passenger}.kid`, null);
    } else {
      this.setState({ showKidForm: true });
    }
  };

  render() {
    const {
      seatReservations,
      index,
      foodOptions,
      seatSelectionChangesInProgress,
      passenger,
    } = this.props;

    const {
      customerDisabled,
      underageDisabled,
      showUnderageExtraFields,
      grownUpPassenger,
      underagePassenger,
      relationship,
      needNotarizedPermit,
      travelsOnly,
      showKidForm,
      isValidAge,
      isAgeBetween15And18,
    } = this.state;

    let foodInput = null;
    if (foodOptions) {
      foodInput = (
        <FormGroup row>
          <FormItem label="Alimento" required>
            <Field
              name={`${passenger}.food`}
              component={Select}
              options={foodOptions}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
      );
    }

    let route = null;
    let deleteButton = null;
    if (seatReservations[index]) {
      const {
        itinerary: {
          originName,
          destinationName,
          serviceName,
          departureTime,
          arrivalTime,
        },
      } = seatReservations[index];

      // departure
      const formattedDepartureDate = tzNormalizeDate({
        date: departureTime,
        format: DATE_TIME_FORMAT,
      });

      // arrival
      const formattedArrivalDate = tzNormalizeDate({
        date: arrivalTime,
        format: DATE_TIME_FORMAT,
      });

      route = (
        <>
          <div className="mr-2">({serviceName})</div>
          <div className="text-center">
            {originName}{' '}
            <p>
              <small>{formattedDepartureDate}</small>
            </p>
          </div>
          <div className="mr-3 ml-3"> &rarr; </div>
          <div className="text-center">
            {destinationName}{' '}
            <p>
              <small>{formattedArrivalDate}</small>
            </p>
          </div>
        </>
      );

      let deselectSeatFunction = null;

      if (seatSelectionChangesInProgress.size === 0) {
        deselectSeatFunction = this.onClickDeselectSeat;
      }

      deleteButton = (
        <i
          className="fa fa-times fa-2x text-danger clickable"
          role="button"
          onClick={deselectSeatFunction}
          onKeyPress={deselectSeatFunction}
          tabIndex={0}
        />
      );
    }
    const kidForm = (
      <>
        <br />
        <br />
        <KidPassengerForm
          passenger={passenger}
          form="PostpaidBookingPassengersForm"
        />
      </>
    );

    let header = null;

    header = (
      <div className="clearfix">
        <div className="float-left">
          <h5>
            <div className="d-flex">
              <div className="mr-3">Pasajero {index + 1}: </div> {route}
            </div>
          </h5>
        </div>
        <div className="float-right">{deleteButton}</div>
      </div>
    );

    const underageExtraFields = showUnderageExtraFields && (
      <>
        <FormGroup row>
          <FormItem label="Relación con el Menor" required>
            <Field
              name={`${passenger}.parent.relationship`}
              component={Select}
              options={
                isAgeBetween15And18
                  ? enumToSelectOptions(RELATIONSHIP_TO_MINOR)
                  : enumToSelectOptions(RELATIONSHIP)
              }
              onChange={this.onChangeRelationship}
              validate={[isRequired]}
            />
          </FormItem>
        </FormGroup>
        {needNotarizedPermit && (
          <>
            <div className="alert alert-info">
              <i className="fa fa-info-circle mr-2" />
              Se requiere permiso notariado para que el menor pueda viajar.
            </div>
            <FormGroup row>
              <FormItem label="Permiso Notariado">
                <Field
                  name={`${passenger}.parent.notarizedPermit`}
                  component={TextInput}
                  type="text"
                  placeholder="Ingresar Permiso Notariado"
                />
              </FormItem>
            </FormGroup>
          </>
        )}
        <FormGroup row>
          <FormItem label="Observaciones">
            <Field
              name={`${passenger}.parent.comments`}
              component={TextInput}
              type="textarea"
              placeholder="Observaciones"
            />
          </FormItem>
        </FormGroup>
      </>
    );

    let relationshipText = null;
    if (RELATIONSHIP_TO_MINOR.TRAVELS_ALONE.label === relationship) {
      relationshipText = `${underagePassenger} viaja solo`;
    } else if (RELATIONSHIP.OTHER.label === relationship) {
      relationshipText = `${underagePassenger} tiene otro tipo de relación con ${grownUpPassenger}`;
    } else {
      relationshipText = `${underagePassenger} es ${relationship} de ${grownUpPassenger}`;
    }
    const underageDetails = underagePassenger &&
      grownUpPassenger &&
      relationship && (
        <Badge color="success" text={<small>{relationshipText}</small>} />
      );

    const kidFormButtonText = showKidForm ? (
      <Fragment>
        <i className="fa fa-minus-circle" /> Quitar Menor de 5 años
      </Fragment>
    ) : (
      <Fragment>
        <i className="fa fa-plus-circle" /> Menor de 5 años
      </Fragment>
    );

    return (
      <div>
        <hr />
        {header}
        <CustomerInputGroup
          label="Pasajero"
          labelRequired
          name={`${passenger}.passenger`}
          form="PostpaidBookingPassengersForm"
          mobilePhoneRequired
          disabled={customerDisabled}
          onChange={this.onChangeGrownUpPassenger}
          onEditOrSaveCustomer={(customer) =>
            this.onChangeGrownUpPassenger(customer)
          }
          showDetails
          autoFocus
          useBookingSearch
          canEditNames
        />
        <FormGroup row>
          <FormItem label="">
            <Button
              color="primary"
              outline
              size="sm"
              type="button"
              onClick={this.handleToggleKidForm}
            >
              {kidFormButtonText}
            </Button>{' '}
            {showKidForm && kidForm}
          </FormItem>
        </FormGroup>
        <FormGroup row>
          <FormItem label="Asiento" required>
            <Field
              name={`${passenger}.seatReservation`}
              component={Select}
              options={seatReservations}
              isDisabled
              validate={[isRequired, PassengerForm.hasValidSeat]}
            />
          </FormItem>
        </FormGroup>
        {foodInput}
        <div className="mr-3 ml-3 border rounded shadow-sm">
          <div className="pt-3 pr-3 pl-3 pb-1">
            <h5>Datos del Adulto Responsable: {underageDetails}</h5>
            {!travelsOnly && (
              <CustomerInputGroup
                label="Pasajero"
                name={`${passenger}.parent.customer`}
                form="PostpaidBookingPassengersForm"
                disabled={underageDisabled}
                disabledCreateCustomer
                onChange={this.onChangeUnderagePassenger}
                onEditOrSaveCustomer={() => {}}
                validate={isValidAge ? [] : [isRequired, dobIsRequired]}
                showDetails
                isClearable
                useBookingSearch
                canEditNames
              />
            )}
            {underageExtraFields}
          </div>
        </div>
      </div>
    );
  }
}

PostpaidBookingPassengerForm.propTypes = {
  index: PropTypes.number.isRequired,
  passenger: PropTypes.string.isRequired,
  foodOptions: Select.propTypes.options,
  seatReservations: Select.propTypes.options.isRequired,
  dispatchGetPostpaidBookingItineraryFoodGroup: PropTypes.func.isRequired,
  dispatchChange: PropTypes.func.isRequired,
  itineraryId: PropTypes.number.isRequired,
  dispatchDeselectPostpaidBookingSeat: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fields: PropTypes.object.isRequired,
  seatSelectionChangesInProgress: PropTypes.instanceOf(Immutable.Set)
    .isRequired,
  dispatchClearCustomers: PropTypes.func.isRequired,
};

PostpaidBookingPassengerForm.defaultProps = {
  foodOptions: null,
};

// TODO: refactor and pass booking state from higher component
const mapStateToProps = (state, { index }) => {
  const seatReservations = state.PostpaidBookingUnit.PostpaidBooking.getIn([
    'seats',
    'seatReservations',
  ])
    .map((seatReservation) => ({
      value: seatReservation.id,
      label: seatReservation.seat.seatNumber,
      itinerary: seatReservation.itinerary || null,
      itineraryId: seatReservation.itineraryId || null,
      seatNumber: seatReservation.seat.seatNumber,
      floorNumber: seatReservation.seat.floorNumber,
    }))
    .toJS();

  const seatReservationsOrdered = orderBy(
    seatReservations,
    ['itinerary.departureTime', 'itineraryId', 'label'],
    ['asc'],
  );

  const foodGroup = state.PostpaidBookingUnit.PostpaidBooking.getIn([
    'passengers',
    'itineraryFoodGroup',
  ]);

  let foodOptions = null;
  if (foodGroup && foodGroup.foodSet) {
    foodOptions = foodGroup.foodSet.map((food) => ({
      value: food.id,
      label: food.name,
    }));
  }

  const seatSelectionChangesInProgress =
    state.PostpaidBookingUnit.PostpaidBooking.getIn([
      'seats',
      'seatSelectionChangesInProgress',
    ]);

  const { itineraryId } = seatReservations[index];

  return {
    seatReservations: seatReservationsOrdered,
    foodOptions,
    itineraryId,
    seatSelectionChangesInProgress,
  };
};

const mapDispatchToProps = {
  dispatchGetPostpaidBookingItineraryFoodGroup:
    getPostpaidBookingItineraryFoodGroup,
  dispatchChange: change,
  dispatchDeselectPostpaidBookingSeat: deselectPostpaidBookingSeat,
  dispatchClearCustomers: clearCustomers,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostpaidBookingPassengerForm);
